<template>
    <video muted autoplay loop id="video-bg" v-if="this.$store.state.app.page != 'harkhan' && renderComponent">
        <source :src="videoSrc" type="video/mp4" />
    </video>

    <!--<video muted autoplay loop id="video-bg" v-if="this.$store.state.app.page != 'harkhan'">
        <source :src="require('@/assets/bubbles.mp4')" type="video/mp4" />
    </video>-->

    <Header />
    <Nav />

    <Home v-if="this.$store.state.app.page === 'home'" />
    <Agency v-if="this.$store.state.app.page === 'agency'" />
    <Harkhan v-if="this.$store.state.app.page === 'harkhan'" />
    <Lab v-if="this.$store.state.app.page === 'lab'" />
    <References v-if="this.$store.state.app.page === 'references'" />
    <Technos v-if="this.$store.state.app.page === 'technos'" />

    <Modal />
    <!--<LoaderWebsite />-->

    <!--<div id="scrollbar-hk" @mousemove="mouseMoveScroll" :class="{ active: scrollbarButtonActive !== false }" ref="scrollbar"><div @mouseup="mouseUpScroll" @mouseleave="mouseUpScroll" @mousedown="mouseDownScroll" ref="scrollbarButton"></div></div>-->
</template>

<script>
import { nextTick } from "vue";
import Header from "./components/Header.vue";
import Nav from "./components/Nav.vue";
import Modal from "./components/Modal.vue";
import LoaderWebsite from "./components/LoaderWebsite.vue";
import Home from "./views/Home.vue";
import Agency from "./views/Agency.vue";
import Harkhan from "./views/Harkhan.vue";
import Lab from "./views/Lab.vue";
import References from "./views/References.vue";
import Technos from "./views/Technos.vue";

/*import video1 from "@/assets/motion_projets_2024_test.mp4";
import video2 from "@/assets/showreel.mp4";
import video3 from "@/assets/showreel_en.mp4";
import video4 from "@/assets/showreel_mobil.mp4";
import video5 from "@/assets/showreel_mobil_en.mp4";*/

export default {
    name: "App",
    props: ["page"],
    data() {
        return {
            scrollbar: false,
            scrollbarButton: false,
            scrollbarButtonActive: false,
            mouseActive: false,
            positionMouseInScrollBar: 0,
            videoSrc: null,
            renderComponent: false,
        };
    },
    components: {
        Header,
        Nav,
        Modal,
        LoaderWebsite,
        Home,
        Agency,
        Harkhan,
        Lab,
        References,
        Technos,
    },
    watch: {
        "$i18n.locale": function (locale) {
            localStorage.setItem("locale", locale);
        },
    },
    beforeMount() {
        this.$store.dispatch("app/setPage", this.page);

        // Langue
        let locale = localStorage.getItem("locale");
        if (locale) {
            this.$root.$i18n.locale = locale;
        }
    },
    mounted() {
        window.addEventListener("load", () => {
            this.videoSrc = require("@/assets/bubbles.mp4");
            this.forceRerender();
            
            /*const videosToPreload = [video1, video2, video3, video4, video5];

            videosToPreload.forEach((src) => {
                fetch(src)
                    .then((response) => {
                        if (!response.ok) throw new Error(`Erreur HTTP ${response.status}`);
                        return response.blob();
                    })
                    .catch((err) => {
                        console.warn(`Échec préchargement ${src}:`, err);
                    });
            });*/

        });
    },
    methods: {
        async forceRerender() {
            this.renderComponent = false;
            await nextTick();
            this.renderComponent = true;
        },
        mouseDownScroll() {
            this.scrollbarButtonActive = true;
            this.scrollbar = this.$refs.scrollbar;
            this.scrollbarButton = this.$refs.scrollbarButton;
        },
        mouseUpScroll() {
            this.scrollbarButtonActive = false;
            this.mouseActive = false;
        },
        mouseMoveScroll(e) {
            if (this.scrollbarButtonActive === false) return;

            // Hauteur total page
            var body = document.body,
                html = document.documentElement;
            var bodyHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

            // Hauteur bouton scroll
            let scrollbarHeight = this.scrollbar.getBoundingClientRect().height;

            // Position (top) de la souris
            let mousePositionTop = e.clientY;
            if (this.mouseActive === false) this.positionMouseInScrollBar = mousePositionTop - this.scrollbarButton.getBoundingClientRect().top;
            this.mouseActive = true;

            let newPositionScrollButton = mousePositionTop - this.positionMouseInScrollBar;

            if (newPositionScrollButton >= scrollbarHeight) return false;
            if (newPositionScrollButton <= 0) return false;

            this.scrollbarButton.style.transform = `translate3d(0px, ${newPositionScrollButton}px, 0px)`;

            let percentTopScroll = (this.scrollbarButton.getBoundingClientRect().top * 100) / scrollbarHeight;
            let newPositionTopScroll = (percentTopScroll * bodyHeight) / 100;
            window.scrollTo({
                top: newPositionTopScroll,
            });
        },
    },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");

.grecaptcha-badge {
    opacity: 0;
}

html,
body {
    margin: 0;
    padding: 0;
    font-family: "Roboto", sans-serif;
    //background-color: #f5f5f5;
    background-color: #def0ff;
}

body {
    background: url("@/assets/img/hk_background.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    //background: green;
}

body.hidden {
    overflow: hidden;
}

.container {
    width: 100%;
    margin: auto;
    padding: 0 2rem;
    box-sizing: border-box;
    /*z-index: 2;
    position: relative;*/
}

.bold {
    font-weight: 600;
}

#content {
    padding-top: 125px;
}

#video-bg {
    position: fixed;
    right: 0;
    bottom: 0;
    min-width: 100%;
    min-height: 100%;
}

#scrollbar-hk {
    height: 100vh;
    width: 20px;
    background-color: yellow;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 999;

    /*&.active {
        width: 100%;
    }*/

    > div {
        background-color: rgb(94, 255, 0);
        height: 64px;
        position: absolute;
        z-index: 1;
        width: 20px;
        right: 0;
        //transition: transform 0.2s;
    }
}

/* ===== Scrollbar CSS ===== */
::-webkit-scrollbar {
    width: 12px;
    height: 12px;
}
::-webkit-scrollbar-button {
    width: 0px;
    height: 0px;
}
::-webkit-scrollbar-thumb {
    background: #ff0000;
    border: 0px solid #ffffff;
    border-radius: 50px;
}
::-webkit-scrollbar-thumb:hover {
    background: #ff0000;
}
::-webkit-scrollbar-thumb:active {
    background: #ff0000;
}
::-webkit-scrollbar-track {
    background: transparent;
    border: 0px none transparent;
    border-radius: 50px;
}
::-webkit-scrollbar-track:hover {
    background: transparent;
}
::-webkit-scrollbar-track:active {
    background: transparent;
}
::-webkit-scrollbar-corner {
    background: transparent;
}

@media (max-width: 768px) {
    .container {
        padding: 0 1rem;
    }

    #content {
        padding-top: 50px;
    }
}
</style>
